const PREFIX = 'scheduledtasks_'
export const LOADING = PREFIX + 'LOADING'
export const UPDATE_ALL = PREFIX + 'UPDATE_ALL'
export const UPDATE_BY_ID = PREFIX + 'UPDATE_BY_ID'
export const LOG_GROUPS_UPDATE_ALL = PREFIX + 'LOG_GROUPS_UPDATE_ALL'
export const LOGS_BY_GROUP_UPDATE_ALL = PREFIX + 'LOGS_BY_GROUP_UPDATE_ALL'